{
  "status": {
    "draft": "Draft",
    "published": "Published",
    "archived": "Archived"
  },
  "gradingMode": {
    "team": "One team grade",
    "individual": "Per-member grades"
  },
  "taskStatus": {
    "todo": "To do",
    "in_progress": "In progress",
    "done": "Done"
  },
  "submissionStatus": {
    "notStarted": "Not started",
    "draft": "In progress",
    "submitted": "Handed in",
    "returned": "Returned for revision",
    "graded": "Graded"
  },
  "late": "Late",
  "list": {
    "title": "Projects",
    "description": "Team projects you run with a class.",
    "searchPlaceholder": "Search projects…",
    "classFilter": "Class",
    "statusFilter": "Status",
    "anyClass": "Any class",
    "anyStatus": "Any status",
    "table": {
      "project": "Project",
      "class": "Class",
      "team": "Team",
      "tasks": "Cards",
      "due": "Due",
      "status": "Status"
    },
    "team": "{{count}} member",
    "team_other": "{{count}} members",
    "noTeam": "No team yet",
    "progress": "{{done}} / {{total}}",
    "noTasks": "No cards",
    "due": "Due {{date}}",
    "noDue": "No due date",
    "empty": {
      "title": "No projects yet",
      "text": "Create a project for a class, write the brief and pick the team.",
      "filterText": "Nothing matches the current filters."
    },
    "actions": {
      "open": "Open",
      "edit": "Edit",
      "publish": "Publish",
      "unpublish": "Unpublish",
      "duplicate": "Duplicate",
      "archive": "Archive",
      "more": "More actions for {{title}}"
    },
    "published": "Project published",
    "unpublished": "Project moved back to draft",
    "duplicated": "Project duplicated",
    "archived": "Project archived",
    "archiveTitle": "Archive {{title}}?",
    "archiveDescription": "The board freezes and the project disappears for the team. Tasks, comments and grades stay."
  },
  "pupilList": {
    "title": "My projects",
    "description": "Projects your team is working on.",
    "empty": {
      "title": "You are not on a project team",
      "text": "When a teacher puts you on a project team, its brief, board and result appear here."
    },
    "open": "Open project"
  },
  "create": {
    "button": "Create project",
    "title": "Create project",
    "description": "Pick the class and how the result will be graded — the brief and the team come next.",
    "titleLabel": "Title",
    "titlePlaceholder": "e.g. Model of the solar system",
    "classLabel": "Class",
    "classPlaceholder": "Choose a class",
    "noClasses": "No active classes — create a class first.",
    "dueLabel": "Due (optional)",
    "gradingModeLabel": "Grading",
    "maxScoreLabel": "Maximum score",
    "submit": "Create project",
    "success": "Project created",
    "failed": "Could not create the project"
  },
  "detail": {
    "back": "Back to projects",
    "due": "Due {{date}}",
    "noDue": "No due date",
    "maxScore": "Max score: {{score}}",
    "noMaxScore": "No maximum score set — the result cannot be graded yet.",
    "archivedNotice": "This project is archived. The board is frozen and the result can no longer be edited.",
    "draftNotice": "This project is still a draft — the team cannot see it yet.",
    "brief": "Brief",
    "briefEmpty": "The brief is empty.",
    "editBrief": "Edit brief",
    "saveBrief": "Save brief",
    "briefSaved": "Brief saved",
    "briefFailed": "Could not save the brief",
    "briefErrors": "Some blocks need fixing:",
    "cancel": "Cancel"
  },
  "edit": {
    "title": "Project settings",
    "titleLabel": "Title",
    "dueLabel": "Due",
    "gradingModeLabel": "Grading",
    "maxScoreLabel": "Maximum score",
    "save": "Save",
    "saved": "Project updated",
    "failed": "Could not save the project"
  },
  "team": {
    "title": "Team",
    "description": "A project is its team — only these pupils can see it, use the board and hand in the result.",
    "empty": "Nobody is on the team yet.",
    "manage": "Manage team",
    "dialogTitle": "Choose the team",
    "dialogDescription": "Tick the pupils who work on this project. The list you save replaces the whole team.",
    "warning": "Removing a member unassigns their board cards. The cards stay; the project simply disappears for that pupil.",
    "noRoster": "This class has no enrolled pupils yet.",
    "selected": "{{count}} selected",
    "save": "Save team",
    "saved": "Team updated",
    "failed": "Could not update the team"
  },
  "board": {
    "title": "Board",
    "description": "Cards move between the three columns; only staff can delete one.",
    "empty": "No cards in this column.",
    "addTask": "Add card",
    "frozen": "The board is frozen because the project is archived.",
    "moveTo": "Move to",
    "moveLabel": "Column for {{title}}",
    "assignLabel": "Assignee for {{title}}",
    "unassigned": "Unassigned",
    "moveUp": "Move {{title}} up",
    "moveDown": "Move {{title}} down",
    "moved": "Card moved",
    "moveFailed": "Could not move the card — it was put back",
    "reordered": "Board reordered",
    "reorderFailed": "Could not reorder the board — it was put back",
    "deleteTask": "Delete card",
    "deleteTitle": "Delete {{title}}?",
    "deleteDescription": "The card and its comments are removed for good.",
    "deleted": "Card deleted",
    "count": "{{count}} card",
    "count_other": "{{count}} cards"
  },
  "task": {
    "createTitle": "New card",
    "editTitle": "Edit card",
    "titleLabel": "Title",
    "titlePlaceholder": "e.g. Draft the introduction",
    "descriptionLabel": "Description",
    "statusLabel": "Column",
    "assigneeLabel": "Assignee",
    "dueLabel": "Due",
    "save": "Save card",
    "created": "Card added",
    "saved": "Card saved",
    "failed": "Could not save the card",
    "open": "Open {{title}}",
    "close": "Close",
    "noDescription": "No description.",
    "detailTitle": "Card"
  },
  "comments": {
    "title": "Comments",
    "empty": "No comments yet.",
    "placeholder": "Write a comment…",
    "add": "Comment",
    "added": "Comment added",
    "edit": "Edit comment",
    "editing": "Editing your comment",
    "save": "Save",
    "saved": "Comment updated",
    "cancel": "Cancel",
    "delete": "Delete comment",
    "deleteTitle": "Delete this comment?",
    "deleteDescription": "The comment is removed for good.",
    "deleted": "Comment deleted",
    "failed": "Could not save the comment",
    "edited": "edited"
  },
  "deliverable": {
    "title": "Result",
    "description": "One shared result for the whole team — anyone on the team can edit it until it is handed in.",
    "notOpened": "The team has not started the result yet.",
    "textLabel": "Your team's answer",
    "textPlaceholder": "Describe what your team produced",
    "saveDraft": "Save draft",
    "savedDraft": "Draft saved",
    "attachments": "Attachments",
    "addFile": "Add file",
    "addImage": "Add image",
    "addVideo": "Add video",
    "addAudio": "Add audio",
    "linkLabel": "Link (Loom, YouTube, …)",
    "linkPlaceholder": "https://…",
    "linkAdd": "Add",
    "linkAdded": "Link added",
    "uploadProgress": "Upload progress",
    "uploaded": "Attachment added",
    "removeAttachment": "Remove attachment",
    "removed": "Attachment removed",
    "submit": "Hand in",
    "resubmit": "Hand in again",
    "submitTitle": "Hand in the team result?",
    "submitDescription": "Your teacher will see everything the team added here.",
    "submitted": "Result handed in",
    "submitFailed": "Could not hand in the result",
    "returnedNotice": "Your teacher asked for a revision",
    "lockedGraded": "This result has been graded — it is locked. Ask your teacher to return it if the team needs to change something.",
    "feedback": "Teacher feedback",
    "score": "Score {{score}} / {{max}}",
    "yourScore": "Your score",
    "memberScores": "Scores per member",
    "lateNotice": "This was handed in after the due date.",
    "revisions": "Revision {{count}}"
  },
  "review": {
    "title": "Review",
    "description": "The team result, its attachments and the grade.",
    "nothing": "Nothing has been handed in yet.",
    "textAnswer": "Written answer",
    "noText": "No written answer.",
    "attachments": "Attachments",
    "noAttachments": "No attachments.",
    "scoreLabel": "Score (max {{max}})",
    "feedbackLabel": "Feedback",
    "grade": "Grade",
    "graded": "Result graded",
    "return": "Return for revision",
    "returned": "Returned to the team",
    "returnNeedsFeedback": "Write the feedback the team should act on.",
    "failed": "Could not save",
    "memberGrid": "Per-member grades",
    "memberScoreLabel": "Score for {{name}}",
    "memberFeedbackLabel": "Feedback for {{name}}",
    "allMembersRequired": "Every team member needs a score before you can grade.",
    "noMembers": "Add team members before grading this project.",
    "maxScoreMissing": "Set a maximum score on the project before grading it.",
    "gradedBy": "Graded by {{name}} on {{date}}"
  },
  "classSection": {
    "title": "Projects",
    "empty": "No projects for this class yet.",
    "viewAll": "All projects"
  },
  "cards": {
    "myProjectsTitle": "My projects",
    "myProjectsDescription": "Your teams and what is due next.",
    "myProjectsEmpty": "You are not on a project team right now.",
    "toGradeTitle": "Project results to grade",
    "toGradeDescription": "Team results waiting for a grade.",
    "toGradeEmpty": "Nothing waiting.",
    "toGradeCount": "{{count}} result",
    "toGradeCount_other": "{{count}} results",
    "openQueue": "Open the review queue"
  },
  "queue": {
    "title": "Project results to grade",
    "description": "Handed-in team results across your classes.",
    "empty": "Nothing waiting for a grade.",
    "open": "Review"
  },
  "validation": {
    "titleRequired": "Title is required",
    "classRequired": "Choose a class",
    "maxScoreRequired": "Set a maximum score",
    "bodyRequired": "Write something first",
    "scoreRequired": "Enter a score"
  }
}
